var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.investor.info)?_c('b-col',{staticClass:"p-0 sidebar__user_information nice-scroll",attrs:{"cols":"12","lg":"6"}},[_c('div',{staticClass:"p-2"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"text-muted"},[_vm._v("Investor Conditions")])]),_vm._v(" XD ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }